import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { searchResultI } from '@/pages/ProfessionPage/AnalysisPage/ComparisonPage/index'

interface compareTypeListI {
  total: number
  nowComparePage: number
  compareList: searchResultI[]
}

const initialState: compareTypeListI = {
  total: 0,
  nowComparePage: 1,
  compareList: []
}

export const setCompareTypeListSlice = createSlice({
  name: 'setCompareTypeListSlice',
  initialState,
  reducers: {
    setCompareTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload
    },
    setNowComparePage: (state, action: PayloadAction<number>) => {
      state.nowComparePage = action.payload
    },
    setCompareList: (state, action: PayloadAction<searchResultI[]>) => {
      state.compareList = action.payload
    }
  }
})
export const { setCompareTotal, setCompareList, setNowComparePage } =
  setCompareTypeListSlice.actions
export default setCompareTypeListSlice.reducer
